<template>
  <b-card border-variant="dark" title="ویدیو و صوت مصاحبه">
      <b-overlay
          :show="loading"
          rounded="sm">
        <b-row>
            <b-col sm="4" md="3">
                <upload-media
                    v-model="fileData.video.file"
                    accept=".mp4,.mov,.wmv"
                    icon="FilmIcon"
                    label="انتخاب ویدئو"
                    style="margin-bottom: 10px"
                    @delete="deleteFile(hero.TeaserVideo, 'TeaserVideo')"
                    @updated="updated = 'video'"
                />
                <b-dropdown
                        v-if="hero.TeaserVideo && updated !== 'video'"
                        right
                        size="sm"
                        :variant="mediaStatus(fileData.video.status).badge"
                >
                    <template #button-content>
                        <b-badge
                                size="sm"
                                style="padding: 0"
                                :variant="mediaStatus(fileData.video.status).badge"
                                v-text="mediaStatus(fileData.video.status).text"
                        />
                    </template>
                    <template>
                        <b-dropdown-item
                                v-for="(status,index) in enums('heroGalleryStatus')"
                                :key="index"
                                @click="changeStatus(status, hero.TeaserVideo.Id, 'video')"
                        >
                            {{ status.text }}
                        </b-dropdown-item>
                    </template>
                </b-dropdown>
                <b-button
                    v-else-if="fileData.video.file"
                    block
                    variant="primary"
                    size="sm"
                    @click="submit(hero.TeaserVideo, fileData.video)"
                >ذخیره
                </b-button>
            </b-col>
            <b-col sm="4" md="3">
                <upload-media
                    v-model="fileData.audio.file"
                    accept=".mp3"
                    icon=""
                    label="انتخاب فایل صوتی"
                    style="margin-bottom: 10px"
                    @delete="deleteFile(hero.SoundInterview, 'SoundInterview')"
                    @updated="updated = 'audio'"
                />
                <b-dropdown
                        v-if="hero.SoundInterview && updated !== 'audio'"
                        right
                        size="sm"
                        :variant="mediaStatus(fileData.audio.status).badge"
                >
                    <template #button-content>
                        <b-badge
                                size="sm"
                                style="padding: 0"
                                :variant="mediaStatus(fileData.audio.status).badge"
                                v-text="mediaStatus(fileData.audio.status).text"
                        />
                    </template>
                    <template>
                        <b-dropdown-item
                                v-for="(status,index) in enums('heroGalleryStatus')"
                                :key="index"
                                @click="changeStatus(status, hero.SoundInterview.Id, 'audio')"
                        >
                            {{ status.text }}
                        </b-dropdown-item>
                    </template>
                </b-dropdown>
                <b-button
                    v-else-if="fileData.audio.file"
                    block
                    variant="primary"
                    size="sm"
                    @click="submit(hero.SoundInterview, fileData.audio)"
                >ذخیره
                </b-button>
            </b-col>
            <b-col sm="4" md="3">
              <upload-media
                  v-model="fileData.landingCover.file"
                  icon="ImageIcon"
                  label="انتخاب کاور لندینگ"
                  style="margin-bottom: 10px"
                  @delete="deleteFile(hero.LandingCover, 'LandingCover')"
                  @updated="updated = 'landingCover'"
              />
                <b-dropdown
                        v-if="hero.LandingCover && updated !== 'landingCover'"
                        right
                        size="sm"
                        :variant="mediaStatus(fileData.landingCover.status).badge"
                >
                    <template #button-content>
                        <b-badge
                                size="sm"
                                style="padding: 0"
                                :variant="mediaStatus(fileData.landingCover.status).badge"
                                v-text="mediaStatus(fileData.landingCover.status).text"
                        />
                    </template>
                    <template>
                        <b-dropdown-item
                                v-for="(status,index) in enums('heroGalleryStatus')"
                                :key="index"
                                @click="changeStatus(status, hero.LandingCover.Id, 'landingCover')"
                        >
                            {{ status.text }}
                        </b-dropdown-item>
                    </template>
                </b-dropdown>
                <b-button
                        v-else-if="fileData.landingCover.file"
                        block
                        variant="primary"
                        size="sm"
                        @click="submit(hero.LandingCover, fileData.landingCover)"
                >ذخیره
                </b-button>
            </b-col>
            <b-col sm="4" md="3">
            <upload-media
                v-model="fileData.appCover.file"
                icon="ImageIcon"
                label="انتخاب کاور اپ"
                style="margin-bottom: 10px"
                @delete="deleteFile(hero.AppCover, 'AppCover')"
                @updated="updated = 'appCover'"
            />
            <b-dropdown
                v-if="hero.AppCover && updated !== 'appCover'"
                right
                size="sm"
                :variant="mediaStatus(fileData.appCover.status).badge"
            >
              <template #button-content>
                <b-badge
                    size="sm"
                    style="padding: 0"
                    :variant="mediaStatus(fileData.appCover.status).badge"
                    v-text="mediaStatus(fileData.appCover.status).text"
                />
              </template>
              <template>
                <b-dropdown-item
                    v-for="(status,index) in enums('heroGalleryStatus')"
                    :key="index"
                    @click="changeStatus(status, hero.AppCover.Id, 'appCover')"
                >
                  {{ status.text }}
                </b-dropdown-item>
              </template>
            </b-dropdown>
            <b-button
                v-else-if="fileData.appCover.file"
                block
                variant="primary"
                size="sm"
                @click="submit(hero.AppCover, fileData.appCover)"
            >ذخیره
            </b-button>
          </b-col>
          </b-row>
      </b-overlay>
  </b-card>
</template>

<script>

import uploadFile from "@/tools/uploadFile.vue";
import uploadMedia from "@/tools/media/uploadMedia.vue";
export default {
  name: "heroAddGalleryAdmin",
  components: {uploadFile, uploadMedia},
  props: {
    hero: { type: Object, default: null }
  },
  data() {
    return {
      loading: false,
      updated: '',
      fileData: {
        video: {
          key: 'TeaserVideo',
          file: null,
          type: 3,
          status: ''
        },
        audio: {
          key: 'SoundInterview',
          file: null,
          type: 4,
          status: ''
        },
        landingCover: {
          key: 'LandingCover',
          file: null,
          type: 5,
          status: ''
        },
        appCover: {
          key: 'AppCover',
          file: null,
          type: 6,
          status: ''
        }
      },
      beforeAdding: false
    }
  },
  computed: {
    userId() {
      return this.$route.params.id
    }
  },
  watch: {
    hero: {
      immediate: true,
      handler(data) {
        if (data) {
          this.fileData.video.file = data.TeaserVideo && data.TeaserVideo.Url
          this.fileData.video.status = data.TeaserVideo && data.TeaserVideo.Status
          this.fileData.audio.file = data.SoundInterview && data.SoundInterview.Url
          this.fileData.audio.status = data.SoundInterview && data.SoundInterview.Status
          this.fileData.landingCover.file = data.LandingCover && data.LandingCover.Url
          this.fileData.landingCover.status = data.LandingCover && data.LandingCover.Status
          this.fileData.appCover.file = data.AppCover && data.AppCover.Url
          this.fileData.appCover.status = data.AppCover && data.AppCover.Status
        }
      }
    }
  },
  methods: {
    changeStatus(status, id, type) {
      this.loading = true
      const data = {
        UserId: this.userId,
        Status: status.value,
        Id: id
      }
      this.$http.post(this.$api.hero.heroGalleryStatus, data)
          .then(() => {
            this.loading = false
              this.fileData[type].status = status.value
          })
          .finally(() => {
            this.loading = false
          })
    },
    deleteFile(data, key) {
      this.loading = true
      return this.$http.post(this.$api.hero.removeHeroGallery, {
          UserId: this.userId,
          Id: data.Id
      })
          .then(() => {
              this.loading = false
              if (!this.beforeAdding) {
                let item = {
                  ...this.hero,
                  [key]: null
                }
                this.$emit('update:hero', item)
              }
          })
          .finally(() => {
              this.loading = false
          })
    },
    save(data) {
      let url = this.$api.hero.addGalleryHero
      const formData = new FormData()
      formData.append('File', data.file)
      formData.append('Type', data.type)
      formData.append('UserId', this.userId)

      this.loading = true
      this.$http.post(url, formData)
          .then(res => {
            let item = {
              ...this.hero,
              [data.key]: {
                ...res.data
              }
            }
            this.$emit('update:hero', item)
            this.loading = false
            this.updated = false
          })
          .finally(() => {
            this.loading = false
          })
    },
    async submit(data, form) {
        if (data && data.Url) {
            this.beforeAdding = true
            await this.deleteFile(data)
            this.save(form)
            this.beforeAdding = false
        }
        else this.save(form)
    },
    mediaStatus(status) {
      return this.enums('heroGalleryStatus', 'value', status)
    }
  }
}
</script>
